import React from 'react';

type AddContainerLineProps = {
  id?: string;
  rowIndex: number;
  onAdd: (rowIndex: number) => void;
  orientation: 'horizontal' | 'vertical';
}

export const AddContainerLine = ({ id, rowIndex, onAdd, orientation }: AddContainerLineProps) => {
  const baseId = id || 'add-container-line';

  if (orientation === 'horizontal') {
    return (
      <div id={baseId} data-testid={baseId} className="tw-relative tw-flex tw-items-center tw-group tw-h-5 tw-cursor-pointer tw-mb-0.5">
        <div id={`${baseId}-line-left`} className="tw-flex-grow tw-h-px tw-bg-transparent group-hover:tw-bg-[#1F7AE4] tw-transition-colors tw-duration-200"></div>
        <div id={`${baseId}-button-wrapper`} className="tw-px-2">
          <button
            id={`${baseId}-add-btn`}
            data-testid={`${baseId}-add-btn`}
            className="tw-w-5 tw-h-5 tw-rounded-full tw-bg-transparent tw-text-transparent group-hover:tw-bg-[#1F7AE4] group-hover:tw-text-white tw-flex tw-items-center tw-justify-center tw-shadow-none group-hover:tw-shadow-md tw-transition-all tw-duration-200"
            onClick={() => onAdd(rowIndex)}
          >
            <span id={`${baseId}-icon`} className="tw-text-base">+</span>
          </button>
        </div>
        <div id={`${baseId}-line-right`} className="tw-flex-grow tw-h-px tw-bg-transparent group-hover:tw-bg-[#1F7AE4] tw-transition-colors tw-duration-200"></div>
      </div>
    );
  }

  // vertical orientation
  return (
    <div id={baseId} data-testid={baseId} className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-group tw-cursor-pointer tw-self-stretch tw-px-1 tw-min-h-full">
      <div id={`${baseId}-line-top`} className="tw-flex-1 tw-min-h-[40px] tw-w-px tw-bg-transparent group-hover:tw-bg-[#1F7AE4] tw-transition-colors tw-duration-200"></div>
      <button
        id={`${baseId}-add-btn`}
        data-testid={`${baseId}-add-btn`}
        className="tw-w-5 tw-h-5 tw-rounded-full tw-bg-transparent tw-text-transparent group-hover:tw-bg-[#1F7AE4] group-hover:tw-text-white tw-flex tw-items-center tw-justify-center tw-shadow-none group-hover:tw-shadow-md tw-transition-all tw-duration-200 tw-my-2"
        onClick={() => onAdd(rowIndex)}
      >
        <span id={`${baseId}-icon`} className="tw-text-base">+</span>
      </button>
      <div id={`${baseId}-line-bottom`} className="tw-flex-1 tw-min-h-[40px] tw-w-px tw-bg-transparent group-hover:tw-bg-[#1F7AE4] tw-transition-colors tw-duration-200"></div>
    </div>
  );
};
